import React from 'react'
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom'

function useLegacyRouterProps(routePath = '') {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()

  return {
    navigate,
    location,
    params,
    history: {
      location,
      push: (to, state) => navigate(to, { state }),
      replace: (to, state) => navigate(to, { replace: true, state }),
      go: (delta) => navigate(delta),
      goBack: () => navigate(-1),
      back: () => navigate(-1),
    },
    match: {
      path: routePath,
      url: location.pathname,
      params,
      isExact: true,
    },
  }
}

export function RouteElement({ component: Component, routePath, ...props }) {
  const routerProps = useLegacyRouterProps(routePath)
  return <Component {...props} {...routerProps} />
}

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const routerProps = useLegacyRouterProps(props.routePath)
    return <Component {...props} {...routerProps} />
  }

  ComponentWithRouterProp.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`

  return ComponentWithRouterProp
}

export function Redirect({ to }) {
  if (typeof to === 'string') {
    return <Navigate to={to} replace />
  }

  return <Navigate to={to.pathname || '/'} state={to.state} replace />
}